module.exports = __webpack_public_path__ + "img/offical.24380f5a.png";